import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f895d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manga-name single-line-text-overflow" }
const _hoisted_2 = { class: "manga-content" }
const _hoisted_3 = { class: "manga-name" }
const _hoisted_4 = { class: "tag-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 矩形视图 "),
    ($setup.props.viewType !== 'list')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "manga",
          onClick: $setup.go_chapter
        }, [
          _createCommentVNode("封面图片"),
          ($setup.blobLink)
            ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                class: "anim cover-img",
                src: $setup.blobLink,
                fit: $setup.fit,
                alt: $setup.mangaName
              }, null, 8 /* PROPS */, ["src", "alt"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode("占位图标"),
                _createVNode(_component_el_image, {
                  class: "cover-img",
                  src: $setup.placeholder,
                  fit: "fill"
                }, null, 8 /* PROPS */, ["src"])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
          _createCommentVNode("漫画名称"),
          _createElementVNode("p", _hoisted_1, _toDisplayString($setup.mangaName), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" 列表视图 "),
          _createElementVNode("div", {
            class: "manga-view-list",
            onClick: $setup.go_chapter
          }, [
            _createCommentVNode("封面图片"),
            ($setup.blobLink)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  class: "anim cover-img",
                  src: $setup.blobLink,
                  fit: $setup.fit,
                  alt: $setup.mangaName
                }, null, 8 /* PROPS */, ["src", "alt"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode("占位图标"),
                  _createVNode(_component_el_image, {
                    class: "cover-img",
                    src: $setup.placeholder,
                    fit: "fill"
                  }, null, 8 /* PROPS */, ["src"])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
            _createCommentVNode("漫画名称"),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString($setup.mangaName), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.mangaInfo.tags, (tagItem) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    class: "tag base-tag",
                    color: tagItem.tagColor,
                    key: tagItem.tagId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tagItem.tagName), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}